//@ts-check
import { Viewer } from './Viewer.js'

/**
 * Initiates new Viewer Manager
 * @class
 */
class ViewerMgr {
    /**
     * @constructs ViewerMgr
     */
    constructor() {
        this.viewArray = [];
    }

    /**
     * Adds a viewer
     * @param {HTMLDivElement} canvas - The canvas element to add the viewer  
     * @param {string} name - id 
     * @param {Object} [defaultParam = undefined] default parameters
     * @returns {Object} Return success or error messages 
     */
    addViewer(canvas, name, defaultParam = undefined) {
        try {
            var isfound = false;
            for (let i = 0; i < this.viewArray.length; i++) {
                if (this.viewArray[i].name == name) {
                    isfound = true;
                    break;
                }
            }
            if (isfound == false) {
                var viewerInstance;
                if (defaultParam != undefined) {
                    viewerInstance = new Viewer(defaultParam);
                }
                else {
                    viewerInstance = new Viewer({});
                }
                viewerInstance.addViewer(canvas, name);
                this.resizeOberserverInit(canvas, viewerInstance)
                this.viewArray.push(viewerInstance);
                ttcore.animate();
                var returnValue = {
                    "status": "success",
                    "message": "Viewer added successfully."
                }
                return returnValue;
            }
            else {
                var returnValue = {
                    "status": "failed",
                    "message": "ERROR : Viewer with given name already exists, please use different viewer name."
                }
                return returnValue;
            }
        }
        catch (err) {
            var returnValue = {
                "status": "failed",
                "message": "System Error : " + err.message
            }
            return returnValue;
        }
    }

    /**
     * Gets all Viewers
     * @returns {Array<Viewer>} Returns array of the viewers if fails returns error message
     */
    getAllViewers() {
        try {
            if (this.viewArray.length >= 1) {
                return this.viewArray;
            }
            else {
                var returnValue = {
                    "status": "failed",
                    "message": "ERROR : No viewer found."
                }
                return returnValue;
            }
        }
        catch (err) {
            var returnValue = {
                "status": "failed",
                "message": "System Error : " + err.message
            }
            return returnValue;
        }
    }

    /**
     * Get Viewer by Name
     * @param {string} name - Name as id
     * @returns {Viewer} return viewer otherwise error message 
     */
    getViewerByName(name) {
        try {
            if (this.viewArray.length >= 1) {
                for (let i = 0; i < this.viewArray.length; i++) {
                    if (this.viewArray[i].name == name) {
                        return this.viewArray[i];
                    }
                }
                var returnValue = {
                    "status": "success",
                    "message": "Viewer returned successfully."
                }
                return returnValue;
            }
            else {
                var returnValue = {
                    "status": "failed",
                    "message": "ERROR : No viewer found."
                }
                return returnValue;
            }
        }
        catch (err) {
            var returnValue = {
                "status": "failed",
                "message": "System Error: " + err.message
            }
            return returnValue;
        }
    }

    /**
     * Gets Number of Viewers 
     * @returns {Number} Returns number of the viewer
     */
    getViewersCount() {
        return this.viewArray.length;
    }

    /**
     * Clears all Viewers
     * @returns {Object} Return success or error messages 
     */
    clearAllViewers() {
        try {
            if (this.viewArray.length >= 1) {
                this.viewArray.forEach(function (viewer) {
                    viewer.destroy();
                })
                while (this.viewArray.length) {
                    this.viewArray.pop();
                }
                var returnValue = {
                    "status": "success",
                    "message": "All viewers are removed."
                }
                return returnValue;
            }
            else {
                var returnValue = {
                    "status": "failed",
                    "message": "ERROR : No viewer found."
                }
                return returnValue;
            }
        }
        catch (err) {
            var returnValue = {
                "status": "failed",
                "message": "System Error: " +  err.message
            }
            return returnValue;
        }
    }
    /**
     * Clear Viewer by Name
     * @param {string} name - Name or id
     * @returns {Object} Return success or error messages 
     */
    clearViewerByName(name) {
        try {
            if (this.viewArray.length >= 1) {
                let didWork = false;
                for (let i = 0; i < this.viewArray.length + 1; i++) {
                    if (this.viewArray[i]['name'] == name) {
                        this.viewArray[i].destroy();
                        this.viewArray.splice(i, 1);
                        didWork = true;
                        break;
                    }
                }
                if (didWork) {
                    var returnValue = {
                        "status": "success",
                        "message": "Viewer is removed."
                    }
                    return returnValue;
                } else {
                    var returnValue = {
                        "status": "failed",
                        "message": "ERROR : No viewer with name " + name + " found."
                    }
                    return returnValue;
                };
            }
            else {
                var returnValue = {
                    "status": "failed",
                    "message": "ERROR : No viewer found."
                }
                return returnValue;
            }
        }
        catch (err) {
            var returnValue = {
                "status": "failed",
                "message": "System Error:" + err.message
            }
            return returnValue;
        }
    }

    /**
     * Initiate Resize Observer
     * @param {HTMLDivElement} canvas 
     * @param {Viewer} viewerInstance 
     */
    resizeOberserverInit(canvas, viewerInstance) {
        function onResize() {
            if (viewerInstance.canvas != undefined) {
                const newAspectRatio = viewerInstance.canvas.offsetWidth / viewerInstance.canvas.offsetHeight;
                viewerInstance.camera.aspect = newAspectRatio;

                const frustumSize = 100;
                viewerInstance.camera.left = (-frustumSize * newAspectRatio) / 2;
                viewerInstance.camera.right = (frustumSize * newAspectRatio) / 2;
                viewerInstance.camera.top = frustumSize / 2;
                viewerInstance.camera.bottom = -frustumSize / 2;
                viewerInstance.camera.updateProjectionMatrix();
                viewerInstance.renderer.setSize(viewerInstance.canvas.offsetWidth, viewerInstance.canvas.offsetHeight, !0);
                //viewerInstance.renderer.render(viewerInstance.scene, viewerInstance.camera);
                viewerInstance.labelRenderer.setSize(viewerInstance.canvas.offsetWidth, viewerInstance.canvas.offsetHeight);
                //viewerInstance.labelRenderer.render(viewerInstance.scene, viewerInstance.camera);
            }
        }
        function throttle(f, delay) {
            let timer = 0;
            return function (...args) {
                clearTimeout(timer);
                timer = setTimeout(() => f.apply(this, args), delay);
            }
        }

        let resizeObserver = new ResizeObserver(throttle(onResize, 100));
        resizeObserver.observe(canvas);
        viewerInstance.resizeObserver = resizeObserver;
    }

    /**
     * Render
     */
    render() {
        for (let i = 0; i < this.viewArray.length; i++) {
            this.viewArray[i].orbitControls.update();
            this.viewArray[i].labelUpdate();
            this.viewArray[i].renderer.render(this.viewArray[i].scene, this.viewArray[i].camera);
            this.viewArray[i].labelRenderer.render(this.viewArray[i].scene, this.viewArray[i].camera);
            this.viewArray[i].composer.render();
            this.viewArray[i].updateTween();
        }
    }
}

/**
 * Viewer Manager Instance
 * @constant 
 * @type {ViewerMgr} 
 */
const viewerMgrInstance = new ViewerMgr();
Object.freeze(viewerMgrInstance);

var ttcore = {
    animate: function () {
        requestAnimationFrame(ttcore.animate);
        viewerMgrInstance.render();
    }
}

export default viewerMgrInstance;